import React, { useMemo, useRef, useState } from "react";
import { Wave } from "../../../atoms";
import CardCarousel from "../../../atoms/CardCarousel";
import SectionCarousel from "../../../atoms/SectionCarousel";
import { cardLomba, cardContentLomba } from "./shared/DataJenisLomba";

const JenisLomba = () => {
  const containerRef = useRef();
  const [activeCarousel, setActiveCarousel] = useState(1);

  useMemo(() => {
    if (containerRef?.current) {
      containerRef.current.scrollLeft = (activeCarousel - 1) * 150;
    }
  }, [activeCarousel]);

  /**
   * onCarouselChange is event for identifying active slider
   */
  const onCarouselChange = (current) => setActiveCarousel(current);

  return (
    <div className="jenis-lomba2">
      <Wave
        type="flex-up"
        fill="#dde2e8"
        classNames="jenis-lomba2__wave banner__wave"
      />
      <div className="jenis-lomba2__carousel" id="daftar-lomba">
        <h1>Cabang Pertandingan</h1>
        <div ref={containerRef} className="jenis-lomba2__carousel-wrapper">
          <CardCarousel
            cardLomba={cardLomba}
            activeCarousel={activeCarousel}
            setActiveCarousel={setActiveCarousel}
          />
        </div>
        <SectionCarousel
          onChange={onCarouselChange}
          activeCarousel={activeCarousel}
          cardContentLomba={cardContentLomba}
        />
      </div>
      <Wave
        type="down-first"
        fill="#89c353"
        classNames="banner__wave banner__wave"
      />
      {/* removed since guest star removal */}
      {/* <Wave
        type="flex-bottom"
        fill="#ffffff"
        classNames="banner__wave banner__wave"
      /> */}
    </div>
  );
};

export default JenisLomba;
